/* ==========================================================================
   Searcher > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

/* Initial state */
const initialState = {
    locked: false,
    origin: null,
    destination: null,
    dates: [],
    datesEnable: [],
    accommodation: null,
    discounts: false,
    bonus: false,
    route: {},
    vehicles: null,
    vehicle: null,
    vehicleHeight: null,
    vehicleLength: null,
    trailer: false,
    trailerHeight: null,
    trailerLength: null,
    hasError: false,
    errorMessage: null,
    componentError: null,
    panelOpen: false,
    panelClose: false,
    hasPanel: false
};

function handleVehicleData(state, action) {
    return {
        ...state,
        vehicles: action.payload.vehicles || state.vehicles,
        vehicle: action.payload.vehicle || state.vehicle,
        vehicleHeight: 'vehicleHeight' in action.payload ? action.payload.vehicleHeight : state.vehicleHeight,
        vehicleLength: 'vehicleLength' in action.payload ? action.payload.vehicleLength : state.vehicleLength,
        trailer: 'trailer' in action.payload ? action.payload.trailer : state.trailer,
        trailerHeight: 'trailerHeight' in action.payload ? action.payload.trailerHeight : state.trailerHeight,
        trailerLength: 'trailerLength' in action.payload ? action.payload.trailerLength : state.trailerLength
    };
}

function handleChangeData(state, action) {
    return {
        origin: 'origin' in action.payload ? action.payload.origin : state.origin,
        destination: 'destination' in action.payload ? action.payload.destination : state.destination,
        dates: 'dates' in action.payload ? action.payload.dates : state.dates,
        datesEnable: 'datesEnable' in action.payload ? action.payload.datesEnable : state.datesEnable,
        accommodation: 'accommodation' in action.payload ? action.payload.accommodation : state.accommodation,
        discounts: 'discounts' in action.payload ? action.payload.discounts : state.discounts,
        bonus: 'bonus' in action.payload ? action.payload.bonus : state.bonus,
        route: 'route' in action.payload ? action.payload.route : state.route,
        url: action.payload.url || state.url
    };
}

/* Reducer */
function reducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_DATA:
        case types.CHANGE_DATA:
            return {
                ...state,
                ...handleChangeData(state, action)
            };
        case types.SET_VEHICLE:
        case types.CHANGE_VEHICLE:
            return { ...handleVehicleData(state, action) };
        case types.SET_ERROR:
            return {
                ...state,
                hasError: true,
                errorMessage: action.payload.message,
                componentError: action.payload.component
            };
        case types.REMOVE_ERROR:
            return {
                ...state,
                hasError: false,
                errorMessage: null,
                componentError: null
            };
        case types.OPEN_PANEL:
            return {
                ...state,
                panelOpen: action.payload,
                hasPanel: true
            };
        case types.CLOSE_PANEL:
            return {
                ...state,
                panelClose: action.payload,
                hasPanel: false
            };
        case types.LOCK:
            return {
                ...state,
                locked: true
            };
        case types.UNLOCK:
            return {
                ...state,
                locked: false
            };
        case types.DESTROY:
        default:
            return state;
    }
}

/* Exports */
module.exports = {
    reducer
};
